module.exports = __webpack_public_path__ + "static/probook-logo-bb1ee18892491ab6253cef7bff5548f1.png";